import { render, staticRenderFns } from "./aretes.vue?vue&type=template&id=b41c600e&scoped=true"
import script from "./aretes.vue?vue&type=script&lang=js"
export * from "./aretes.vue?vue&type=script&lang=js"
import style0 from "./aretes.vue?vue&type=style&index=0&id=b41c600e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41c600e",
  null
  
)

export default component.exports